// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileApp_mobileAppSection__yAGCe {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #040404;
    margin-top: -12vh;
    padding-bottom: 20vh;
    position: relative;
    overflow: hidden;
  }
  
  .MobileApp_container__1FjFt {
    position: relative;
    max-width: 90rem;
    padding-left: 16px;
    padding-right: 16px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 60px;
  }
  
  .MobileApp_phoneWrapper__roSMX {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .MobileApp_phoneMockupWrapper__69WLi {
    position: relative;
    width: 375px;
  }
  
  .MobileApp_phoneMockup__s\\+XkO {
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: relative;
    z-index: 2;
  }
  
  .MobileApp_screenshot__RRv6W {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: auto;
    opacity: 0;
    transition: opacity 0.5s ease;
    z-index: 1;
  }
  
  .MobileApp_screenshot__RRv6W.MobileApp_visible__G5e2u {
    opacity: 1;
  }
  
  .MobileApp_textWrapper__uACru {
    position: absolute;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    pointer-events: none;
    color: #fff;
    font-size: 14vw;
    font-weight: 700;
    line-height: 1.1;
    max-width: 400px;
    text-wrap: nowrap;
  }
  
  .MobileApp_textLine__lR5BZ {
    display: block;
    transition: transform 0.2s ease-out, opacity 0.2s ease-in-out;
    opacity: 0;
  }
  
  .MobileApp_storeButtonWrapper__kVvb4 {
    display: flex;
    gap: 24px;
    justify-content: center;
  }
  
  .MobileApp_storeButtonWrapper__kVvb4 a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border: 1px solid #fff;
    border-radius: 8px;
    transition: transform 0.3s ease;
    cursor: pointer;
  }
  
  .MobileApp_storeButtonWrapper__kVvb4 a:hover {
    transform: scale(1.05);
  }
  
  .MobileApp_storeButtonWrapper__kVvb4 img {
    width: auto;
    height: 32px;
    padding: 12px 48px;
  }

  @media (max-width: 768px) {
    .MobileApp_storeButtonWrapper__kVvb4 {
      flex-direction: column;
      gap: 16px;
    }
    .MobileApp_phoneMockupWrapper__69WLi {
      width: 100%;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/HomePage/Sections/MobileApp/MobileApp.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,UAAU;IACV,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,6DAA6D;IAC7D,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE;MACE,sBAAsB;MACtB,SAAS;IACX;IACA;MACE,WAAW;IACb;EACF","sourcesContent":[".mobileAppSection {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #040404;\n    margin-top: -12vh;\n    padding-bottom: 20vh;\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .container {\n    position: relative;\n    max-width: 90rem;\n    padding-left: 16px;\n    padding-right: 16px;\n    width: 100%;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 60px;\n  }\n  \n  .phoneWrapper {\n    position: relative;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .phoneMockupWrapper {\n    position: relative;\n    width: 375px;\n  }\n  \n  .phoneMockup {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    position: relative;\n    z-index: 2;\n  }\n  \n  .screenshot {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    height: auto;\n    opacity: 0;\n    transition: opacity 0.5s ease;\n    z-index: 1;\n  }\n  \n  .screenshot.visible {\n    opacity: 1;\n  }\n  \n  .textWrapper {\n    position: absolute;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    pointer-events: none;\n    color: #fff;\n    font-size: 14vw;\n    font-weight: 700;\n    line-height: 1.1;\n    max-width: 400px;\n    text-wrap: nowrap;\n  }\n  \n  .textLine {\n    display: block;\n    transition: transform 0.2s ease-out, opacity 0.2s ease-in-out;\n    opacity: 0;\n  }\n  \n  .storeButtonWrapper {\n    display: flex;\n    gap: 24px;\n    justify-content: center;\n  }\n  \n  .storeButtonWrapper a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    border: 1px solid #fff;\n    border-radius: 8px;\n    transition: transform 0.3s ease;\n    cursor: pointer;\n  }\n  \n  .storeButtonWrapper a:hover {\n    transform: scale(1.05);\n  }\n  \n  .storeButtonWrapper img {\n    width: auto;\n    height: 32px;\n    padding: 12px 48px;\n  }\n\n  @media (max-width: 768px) {\n    .storeButtonWrapper {\n      flex-direction: column;\n      gap: 16px;\n    }\n    .phoneMockupWrapper {\n      width: 100%;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobileAppSection": `MobileApp_mobileAppSection__yAGCe`,
	"container": `MobileApp_container__1FjFt`,
	"phoneWrapper": `MobileApp_phoneWrapper__roSMX`,
	"phoneMockupWrapper": `MobileApp_phoneMockupWrapper__69WLi`,
	"phoneMockup": `MobileApp_phoneMockup__s+XkO`,
	"screenshot": `MobileApp_screenshot__RRv6W`,
	"visible": `MobileApp_visible__G5e2u`,
	"textWrapper": `MobileApp_textWrapper__uACru`,
	"textLine": `MobileApp_textLine__lR5BZ`,
	"storeButtonWrapper": `MobileApp_storeButtonWrapper__kVvb4`
};
export default ___CSS_LOADER_EXPORT___;
